import { createSelector } from 'reselect';
import map from 'lodash/map';
import filter from 'lodash/filter';
import isEmpty from 'lodash/isEmpty';

const getConnAuthById = (state) => state.paging.connAuthById;
const getMetaInfoById = (state) => state.paging.metaInfoById;

export const getConnectionTypes = createSelector(
  [getConnAuthById, getMetaInfoById],
  (connAuthById, metaInfoById) => {
    let connectionTypes = map(connAuthById, (c, k) => {
      return { ...metaInfoById[k], key: k, name: metaInfoById[k].displayName };
    });
    return filter(connectionTypes, (c) => !isEmpty(connAuthById[c.key]));
  },
);
